var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"id":"first","src":require("../../public/image/banner3.png"),"alt":""}}),_c('img',{staticStyle:{"display":"none"},attrs:{"id":"second","src":require("../../public/image/banner32.png"),"alt":""}}),_c('div',{staticClass:"text",class:{en_text:_vm.$i18n.locale=='en'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }